<template>
  <!-- Content -->
  <div class="w-full">
    <div
      :style="{ backgroundImage: 'url(/img/cloud-bg.jpg)' }"
      class="h-120 bg-cover bg-center w-full relative z-10 text-white pb-60 flex flex-col overflow-x-hidden"
    ></div>

    <div
      :style="{ minHeight: '450px' }"
      class="bg-truegray-100 w-full pb-16 flex flex-col items-center lg:items-start"
    >
      <!-- Post content -->
      <div
        :style="{ minHeight: '450px' }"
        class="rounded-xl lg:ml-16 -mt-48 relative z-20 py-16 px-6 lg:p-16 flex w-11/12 lg:w-9/12 transition-all duration-500 relative"
        :class="[
          loading ? 'bg-truegray-500 items-center justify-center' : 'bg-white',
          loading && !mounting ? 'delay-500' : '',
        ]"
      >
        <PostContent :post_id="post_id" />
        <div
          v-if="loading"
          class="h-48 w-48 absolute right-1/2 bottom-1/2 transform translate-x-1/2 translate-y-1/2"
        >
          <lottie :options="loadingAnimationOptions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { mapGetters, mapActions } from 'vuex'
import { EventBus } from '../../../js/plugins/event-bus.js'
import PostContent from '../components/PostContent.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    PostContent,
  },

  mixins: [shared],

  props: {
    post_id: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
      loading: false,
      mounting: true,

      window: {
        width: 0,
        height: 0,
      },

      post: {},
      categories: ['Page', 'News', 'Event', 'Job'],
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },

  watch: {
    post_id: {
      handler: function (id) {
        this.getPost(id)
      },

      deep: true,
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted() {
    this.$set(this, 'mounting', true)
    this.getPost(this.post_id)
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    ...mapActions({
      dispatchSetCurrentCloudPost: 'careerwise/dispatchSetCurrentCloudPost',
    }),

    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    async getPost(id) {
      this.$set(this, 'loading', true)
      await this.dispatchSetCurrentCloudPost(id)
      this.$set(this, 'loading', false)
    },
  },
}
</script>

<style scoped>
.post-intro::after {
  content: '';
  background: #fff;
  height: 1px;
  width: 500px;
  min-width: 95%;
  position: absolute;
  top: 4rem;
  right: 0;
}
</style>
